import { axiosGet } from '@/api/handlers';
import { useQuery } from '@/api/hooks';
import { UsersSnapshotModel } from '../_model/users-snapshot';

export const useUsersSnapshot = ({
  id,
  params,
}: {
  id: string | undefined;
  params: {
    page: number;
    pageSize: number;
  };
}) => {
  return useQuery({
    queryKey: ['users-snapshot', id, params],
    queryFn: async () => {
      const res = await axiosGet(`/api/snapshots/${id}/users/`, params);
      return UsersSnapshotModel.parse(res);
    },
    enabled: !!id,
    gcTime: 60 * 60 * 12 * 1000, // 12時間
    staleTime: 60 * 60 * 12 * 1000, // 12時間
  });
};
